// extracted by mini-css-extract-plugin
module.exports = {"ribbon":"Banner_ribbon__3MrE7"};